import { I18NextPipe } from 'angular-i18next';
import { KeystoneVersion, ProjectIdentifier, TenantIdentifier } from '../credential-forms.model';

export const getKeystoneVersions = (i18n: I18NextPipe) => [
  {
    label: 2,
    value: KeystoneVersion.Second
  },
  {
    label: 3,
    value: KeystoneVersion.Third
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.doNotUse'),
    value: KeystoneVersion.None
  }
];

export const getTenantIdentifiers = (i18n: I18NextPipe) => [
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.tenantName'),
    value: TenantIdentifier.Name
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.tenantID'),
    value: TenantIdentifier.Id
  }
];

export const getDomainIdentifiers = (i18n: I18NextPipe) => [
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.domainName'),
    value: TenantIdentifier.Name
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.domainID'),
    value: TenantIdentifier.Id
  }
];

export const getProjectIdentifiers = (i18n: I18NextPipe) => [
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.projectName'),
    value: ProjectIdentifier.Name
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.projectID'),
    value: ProjectIdentifier.Id
  }
];
